import React from "react";
import { Box, Grid, Typography } from "@mui/material";

export default function MasterclassGallery() {

  const topImages = [
    "https://coaching.rajivwilliams.com/wp-content/uploads/2026/02/4-1.png",
    "https://coaching.rajivwilliams.com/wp-content/uploads/2026/02/3-1.png",
    "https://coaching.rajivwilliams.com/wp-content/uploads/2026/02/1-1.png",
    "https://coaching.rajivwilliams.com/wp-content/uploads/2026/02/2-1.png",
  ];

  const bottomImage =
    "https://coaching.rajivwilliams.com/wp-content/uploads/2026/02/dews.png";

  return (
    <Box
      sx={{
        py: 12,
        px: { xs: 3, md: 12 },
        textAlign: "center",
        background: "#000",
        color: "#fff",
      }}
    >

      {/* TITLE */}
      <Box sx={{ mb: 4 }}>
        <Typography
          variant="h3"
          component="span"
          sx={{
            color: "#fff",
            fontSize: { xs: "30px", md: "35px" },
            fontWeight: 700,
            letterSpacing: 2,
            mr: 1,
          }}
        >
          Why This
        </Typography>

        <Typography
          variant="h1"
          sx={{
            background:
              "linear-gradient(90deg,#ffffff 0%,#d4af37 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            position: "relative",
            display: "inline-block",
            fontWeight: 700,
            fontSize: { xs: "50px", md: "auto" },

            "&::after": {
              content: '""',
              position: "absolute",
              bottom: "0px",
              left: 0,
              width: "100%",
              height: "10px",
              background: "rgb(177 177 177 / 50%)",
              borderRadius: "4px",
            },
          }}
        >
          Masterclass Exists?
        </Typography>
      </Box>

      {/* GRID */}
      <Grid container spacing={3} sx={{ mt: 2 }}>
        {topImages.map((img, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Box
              sx={{
                overflow: "hidden",
                borderRadius: "16px",
                border: "1px solid rgba(15,99,165,0.4)",
                boxShadow: "0 10px 30px rgba(0,0,0,0.8)",
                transition: "all 0.4s ease",

                "&:hover img": {
                  transform: "scale(1.08)",
                },
              }}
            >
              <Box
                component="img"
                src={img}
                sx={{
                  width: "100%",
                  height: 210,
                  objectFit: "cover",
                  display: "block",   // ✅ removes gap
                  transition: "transform 0.6s ease",
                }}
              />
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* LARGE IMAGE */}
      <Box
        sx={{
          mt: 5,
          overflow: "hidden",
          borderRadius: "22px",
          border: "1px solid rgba(15,99,165,0.5)",
          boxShadow: "0 20px 60px rgba(0,0,0,0.9)",

          "&:hover img": {
            transform: "scale(1.04)",
          },
        }}
      >
        <Box
          component="img"
          src={bottomImage}
          sx={{
            width: "100%",
            height: { xs: 260, md: 300 },
            objectFit: "cover",
            display: "block",   // ✅ removes gap
            transition: "transform 0.7s ease",
          }}
        />
      </Box>

      {/* TEXT */}
      <Typography
        variant="h5"
        sx={{
          mt: 5,
          color: "#8fd3ff",
          fontWeight: 500,
          letterSpacing: 0.5,
        }}
      >
        Because Most Businesses Don’t Struggle With Effort
      </Typography>

    </Box>
  );
}